import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { CommonButton } from '@/components/common'
import { downloadCsv } from '@/utils/helpers'

export const DonorsExportButton = ({
  disabled = false,
  csvHeaders = [],
  csvFilename = 'drive-donors.csv',
  fetchExportData,
}) => {
  const [exporting, setExporting] = useState(false)

  const handleExportClick = async () => {
    if (disabled || exporting || !fetchExportData) return

    setExporting(true)
    try {
      const rows = await fetchExportData()
      downloadCsv(rows, csvHeaders, csvFilename)
    } catch (error) {
      console.error('Failed to export drive donors', error)
    } finally {
      setExporting(false)
    }
  }

  return (
    <CommonButton
      variant='secondary'
      startIcon={<FileDownloadOutlinedIcon />}
      onClick={handleExportClick}
      disabled={disabled || exporting}
      loading={exporting}
    >
      {exporting ? 'Exporting...' : 'Export to Excel'}
    </CommonButton>
  )
}

DonorsExportButton.propTypes = {
  disabled: PropTypes.bool,
  csvHeaders: PropTypes.array,
  csvFilename: PropTypes.string,
  fetchExportData: PropTypes.func,
}
